import { createSlice } from "@reduxjs/toolkit";
import { snackbar } from "../../types/slices/customType";
import { RootState } from "../store";

const initialState: snackbar =
{
  show: false,
  alertType: '',
  message:'',
}

const snackbarSlice = createSlice({
  name: 'snackbarSlice',
  initialState,
  reducers:{
    onShowSnackBar (state, {payload}: {payload: any | undefined}) {
        state.show        = true
        state.alertType   = payload.alertType
        state.message     = payload.message
    },
    onHideSnackBar ( state ) {
        state.show        = false
        state.alertType   = ''
        state.message     = ''
    },
  }
})

export const { onShowSnackBar, onHideSnackBar } = snackbarSlice.actions;
export const selectAuth = (state:RootState) => state.snackbarSlice;
export default snackbarSlice.reducer;